<template>
    <div class="w-8"></div>
    <div class="ds-exchange-row-text ds-exchange-col-date">
        <div>{{ date }}</div>
        <div class="ds-exchange-row-secondary">{{ startTime }} - {{ endTime }}</div>
    </div>
    <div class="ds-exchange-row-text ds-exchange-col-position cursor-pointer" @click="emit('view')">
        {{ position }}
    </div>
    <div class="ds-exchange-row-text ds-exchange-col-department cursor-pointer" @click="emit('view')">
        {{ department }}
    </div>
    <div class="ds-exchange-col-status">
       <VacancyStatus :status />
    </div>
    <div class="relative ds-exchange-col-employee">
        <div v-if="assigned">
            <User :first-name="assigned.first_name" :last-name="assigned.last_name" :avatar="assigned.avatar" :subtitle="assigned.position?.name" exchange />
        </div>
        <div v-else class="ds-exchange-row-text pl-3">Нет откликов</div>
    </div> 
    
</template>

<script setup lang="ts">
interface Props {
    vacancy: any,

}
import { computed } from 'vue'
import dayjs from 'dayjs'
import User from '../User.vue';
import VacancyStatus from './VacancyStatus.vue';
const { vacancy } = defineProps<Props>()
const emit = defineEmits(['user', 'view'])

const date = computed(() => dayjs(vacancy.dttm_work_start_at).format('DD.MM.YYYY'))
const startTime = computed(() => dayjs(vacancy.dttm_work_start_at).format('HH:mm'))
const endTime = computed(() => dayjs(vacancy.dttm_work_end_at).format('HH:mm'))
const position = computed(() => vacancy.position.name)
const department = computed(() => vacancy.department.name)
const assigned = computed(() => vacancy.assigned_user)
const status = computed(() => vacancy.status)


</script>
